import {VehicleRepo} from "../api/vehicle/vehicle.repo";
import {DuckDbHelper} from "./duckdb.helper";
import {OrgDto} from "../dto/org.dto";
import {Observable} from "rxjs";
import {WrapperDto} from "../dto/wrapper.dto";
import {VehicleTypeDto} from "../dto/vehicle/vehicle-type.dto";
import {VehicleEngineDto} from "../dto/vehicle/vehicle-engine.dto";
import {map} from "rxjs/operators";
import {inject, Injectable} from "@angular/core";
import {VehicleManufacturerDto} from "../dto/vehicle/vehicle-manufacturer.dto";
import {VehicleModelDto} from "../dto/vehicle/vehicle-model.dto";
import {isDefined} from "../../libs/utils/epic.utils";
import {VehicleVariantDto} from "../dto/vehicle/vehicle-variant.dto";

@Injectable({providedIn: 'root'})
export class VehicleDuckDb extends VehicleRepo {

  private readonly duck = inject(DuckDbHelper);
  private engines: VehicleEngineDto[] | undefined = undefined;
  private types: VehicleTypeDto[] | undefined = undefined;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public override getEngines(_org: OrgDto): Observable<WrapperDto<VehicleEngineDto>> {
    if (isDefined(this.engines)) {
      return DuckDbHelper.datasObs('VehicleEngineDto', this.engines);
    }
    const selectEngine = `
      SELECT engine_id   AS id,
             engine_name AS name,
             ROW_NUMBER()   OVER (ORDER BY engine_id) AS sort
      FROM vehicle
      WHERE engine_id IS NOT NULL
        AND engine_name IS NOT NULL
      GROUP BY engine_id, engine_name`;
    return this.duck.sql(selectEngine).pipe(map((res: any) => {
      if (DuckDbHelper.hasRes(res)) {
        this.engines = res.map((r: any) => new VehicleEngineDto(r));
        return DuckDbHelper.datas('VehicleEngineDto', this.engines!);
      }
      this.engines = [];
      return DuckDbHelper.datas('VehicleEngineDto', []);
    }));
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public override getTypes(_org: OrgDto): Observable<WrapperDto<VehicleTypeDto>> {
    if (isDefined(this.types)) {
      return DuckDbHelper.datasObs('VehicleTypeDto', this.types);
    }
    const selectType = `
      SELECT type_id   AS id,
             type_name AS name,
             ROW_NUMBER() OVER (ORDER BY type_id) AS sort
      FROM vehicle
      WHERE type_id IS NOT NULL
        AND type_name IS NOT NULL
      GROUP BY type_id, type_name`;
    return this.duck.sql(selectType).pipe(map((res: any) => {
      if (DuckDbHelper.hasRes(res)) {
        this.types = res.map((r: any) => new VehicleTypeDto(r));
        return DuckDbHelper.datas('VehicleTypeDto', this.types!);
      }
      // Leer wie in getEngines: Ein leeres VehicleTypeDto hat keinen Namen, und die Fahrzeugseite liest name.startsWith().
      this.types = [];
      return DuckDbHelper.datas('VehicleTypeDto', []);
    }));
  }

  public override getManufacturers(_org: OrgDto, typeId: string): Observable<WrapperDto<VehicleManufacturerDto>> {
    const select = `
      SELECT manufacturer_id   AS id,
             manufacturer_name AS name
      FROM vehicle
      WHERE manufacturer_id IS NOT NULL
        AND manufacturer_name IS NOT NULL
      GROUP BY manufacturer_id, manufacturer_name`;
    return this.duck.sql(select).pipe(map((res: any) => {
      if (DuckDbHelper.hasRes(res)) {
        const manufacturers = res.map((r: any) => {
          const manufacturer = new VehicleManufacturerDto(r);
          manufacturer.typeId = typeId;
          return manufacturer;
        });
        return DuckDbHelper.datas('VehicleManufacturerDto', manufacturers);
      }
      return DuckDbHelper.datas('VehicleManufacturerDto', []);
    }));
  }

  public override getModels(_org: OrgDto, manufacturerId: string): Observable<WrapperDto<VehicleModelDto>> {
    const select = `
      SELECT model_id   AS id,
             model_name AS name
      FROM vehicle
      WHERE model_id IS NOT NULL
        AND model_name IS NOT NULL
      GROUP BY model_id, model_name`;
    return this.duck.sql(select).pipe(map((res: any) => {
      if (DuckDbHelper.hasRes(res)) {
        const models = res.map((r: any) => {
          const model = new VehicleModelDto(r);
          model.manufacturerId = manufacturerId;
          return model;
        });
        return DuckDbHelper.datas('VehicleModelDto', models);
      }
      return DuckDbHelper.datas('VehicleModelDto', []);
    }));
  }

  public override getVariants(_org: OrgDto, modelId: string): Observable<WrapperDto<VehicleVariantDto>> {
    const select = `
      SELECT variant_id   AS id,
             variant_name AS name
      FROM vehicle
      WHERE variant_id IS NOT NULL
        AND variant_name IS NOT NULL
      GROUP BY variant_id, variant_name`;
    return this.duck.sql(select).pipe(map((res: any) => {
      if (DuckDbHelper.hasRes(res)) {
        const variants = res.map((r: any) => {
          const variant = new VehicleVariantDto(r);
          variant.modelId = modelId;
          return variant;
        });
        return DuckDbHelper.datas('VehicleVariantDto', variants);
      }
      return DuckDbHelper.datas('VehicleVariantDto', []);
    }));
  }
}
